import PropTypes from 'prop-types';
import React from 'react';
import { Container } from 'semantic-ui-react';

import Footer from '../../components/Footer';
import PageBackground from '../../components/PageBackground';
import { imageProptypes } from '../../propTypes';
import { HorizontalMenu } from './components/HorizontalMenu';

const PageLayout = ({ background, mobileBackground, menu, menus, children }) => {
  return (
    <>
      <PageBackground image={background} mobile={mobileBackground} />
      <Container>
        <div style={{ paddingBottom: 10 }}>
          {menu && <HorizontalMenu menu={menu} menus={menus} />}
        </div>
        {children}
      </Container>
      <Footer />
    </>
  );
};

PageLayout.defaultProps = {
  background: undefined,
  children: undefined,
  menu: undefined,
  menus: undefined,
  mobileBackground: undefined,
};

PageLayout.propTypes = {
  background: imageProptypes,
  children: PropTypes.node,
  menu: PropTypes.array,
  menus: PropTypes.object,
  mobileBackground: PropTypes.object,
};

export default PageLayout;
